import SchemaPage from '@/docs-partials/api/schema';
import * as React from 'react';
export default {
  SchemaPage,
  React
};